import UserActions from 'bukku/redux/User/actions';
import { useEffect } from "react";
import { useDispatch } from "react-redux";

const {
    readUser,
} = UserActions;

/**
 * To fetch api and initialize the modal visuals
 * @param {Boolean} isIdleModalVisible
 * @param {Object} user - user object from redux
 * @param {Object} focusInputRef - ref to focus on input
 * @param {Object} form - antd form
 */
export const useModalInit = ({isIdleModalVisible, user, focusInputRef, form}) => {
    const dispatch = useDispatch();
    // Initial
    useEffect(() => {
        if (!Object.keys(user).length)
            dispatch(readUser());
    }, [dispatch, user]);

    useEffect(() => {
        if (focusInputRef && focusInputRef.current) {
            focusInputRef.current.focus();
            form.resetFields();
        }
    }, [isIdleModalVisible, form, focusInputRef, user]);
};
